import { routes } from 'constants/routes'
import WsNotifications from 'hooks/WsNotifications/WsNotifications'
import NoMatch from 'pages/NoMatch/NoMatch'
import { Route, Routes } from 'react-router-dom'
import {
  ToastProvider,
  ConfirmProvider,
  CommandPalette,
  InstallPrompt,
} from 'components/UnvUI'

function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <div className="app">
          <Routes>
            {routes.map((route) => (
              <Route key={route.path} path={route.path} element={route.component} />
            ))}
            <Route path="*" element={<NoMatch />} />
          </Routes>
          <WsNotifications />
          <CommandPalette />
          <InstallPrompt />
        </div>
      </ConfirmProvider>
    </ToastProvider>
  )
}

export default App
